<template>
	<b-modal
		:hide-footer="true"
		:hide-header-close="true"
		:no-close-on-backdrop="true"
		:no-close-on-esc="true"
		:title="$t('Add role')"
		centered
		id="add-role"
		no-fade
		size="xl"
	>
		<template v-slot:default>
			<loading-animation
				:active.sync="loading"
				:is-full-page="false"
				:opacity="1"
				color="#5685D8"
			/>
			<form @submit.prevent="addRole" ref="addRole">
				<b-form-group class="mb-2" label-for="name">
					<template v-slot:label
						>{{ $t("Nome") }} <span class="text-danger">*</span></template
					>
					<b-form-input id="name" required v-model="role.name" />
				</b-form-group>
				<label>{{ $t("Permissions") }} <span class="text-danger">*</span></label>

				<!-- Grupos -->
                <div
                    v-for="(permissions, group) in groupedPermissions"
                    :key="group"
                    class="mb-4"
                >
                    <h5 class="text-primary mb-2">
                        {{ group }}
                    </h5>

                    <div class="row m-0">
                        <div
                            v-for="permission in permissions"
                            :key="permission.key"
                            class="col-md-4 p-3"
                            style="border: 1px solid #eee"
                        >
                            {{ permission.label }}

                            <div class="float-right">
                                <toggle-button
                                    :sync="true"
                                    color="#5685D8"
                                    v-model="role.permissions[permission.key]"
                                />
                            </div>
                        </div>
                    </div>
                </div>

				<div class="float-right mt-3">
					<router-link class="btn btn-danger" to="/dashboard/admin/roles">
						<i class="mdi mdi-close" />
						{{ $t("Cancel") }}
					</router-link>
					<button class="btn btn-success btn-submit" data-style="zoom-in" type="submit">
						<i class="mdi mdi-content-save" />
						{{ $t("Create") }}
					</button>
				</div>
			</form>
		</template>
	</b-modal>
</template>

<script>

import { PERMISSION_GROUPS } from "../../../../../permissionGroups";

export default {
	name: "Add",
	mounted() {
		this.$bvModal.show("add-role");
		this.getPermissions();
	},
	data() {
		return {
			loading: true,
			permissionsList: [],
			permissions: [],
			role: {
				name: null,
				permissions: [],
			},
			permissionsLabels: [],
		};
	},
	computed: {
		groupedPermissions() {
			const grouped = {};
			const usedKeys = new Set();

			// Grupos mapeados
			Object.entries(PERMISSION_GROUPS).forEach(
				([groupName, controllers]) => {
					const items = [];

					controllers.forEach(controller => {
						if (this.role.permissions.hasOwnProperty(controller)) {
							items.push({
								key: controller,
								label:
									this.permissionsLabels[controller] ||
									controller,
								value: this.role.permissions[controller]
							});

							usedKeys.add(controller);
						}
					});

					if (items.length) {
						grouped[groupName] = items;
					}
				}
			);

			// Grupo "Outros" (dinâmico)
			const others = [];

			Object.keys(this.role.permissions || {}).forEach(key => {
				if (!usedKeys.has(key)) {
					others.push({
						key,
						label: this.permissionsLabels[key] || key,
						value: this.role.permissions[key]
					});
				}
			});

			if (others.length) {
				grouped["Outros"] = others;
			}

			return grouped;
		}
	},

	methods: {
		// Get permissions list
		getPermissions() {
			// Get all settings values
			axios.get("api/dashboard/roles/permissions").then((response) => {
				this.role.permissions = response.data.data.controllers;
				this.permissionsList = response.data.data.controllers;
				this.permissionsLabels = response.data.data.controllerLabels;
				this.loading = false;
			});
		},
		// Add role
		addRole() {
			let ladda = Ladda.create(document.querySelector(".btn-submit"));
			ladda.start();
			// Send request
			axios.post("api/dashboard/roles", this.role).then((response) => {
				ladda.stop();
				this.$snack.success({
					button: false,
					text: response.data.data.message,
				});
				this.$router.push("/dashboard/admin/roles");
				this.$parent.getRoles();
			});
		},
	},
};
</script>
